import React from 'react'
import BlogPost from './BlogPost'

export default function SmartThings() {
  return (
    <BlogPost
      translationKey="smartThings"
      seoTitle="My Internship at SmartThings | Hyunjin Jae"
      seoDescription="Experiences and learnings from my internship at SmartThings, working on IoT and smart home technology."
      seoKeywords="smartthings, internship, iot, smart home, technology"
      seoTags={['smartthings', 'internship', 'technology', 'iot']}
    />
  )
} 